/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const YoutubeIcon = createIcon({
    displayName: 'YoutubeIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fill: "red",
            d: "M19.667 7.75a2.004 2.004 0 0 0-1.415-1.415C17.004 6 12 6 12 6s-5.004 0-6.25.335a2.004 2.004 0 0 0-1.415 1.414C4 8.996 4 11.6 4 11.6s0 2.604.335 3.851c.184.69.725 1.23 1.414 1.415 1.247.335 6.251.335 6.251.335s5.004 0 6.25-.335a2.004 2.004 0 0 0 1.416-1.415c.334-1.247.334-3.85.334-3.85s0-2.605-.334-3.852Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fill: "#fff",
            d: "m10.4 14 4.158-2.4L10.4 9.2V14Z"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fill: "red",
            d: "M23.5 6.624a3.006 3.006 0 0 0-2.122-2.122C19.505 4 12 4 12 4s-7.505 0-9.376.502A3.006 3.006 0 0 0 .502 6.624C0 8.494 0 12.4 0 12.4s0 3.906.502 5.777A3.006 3.006 0 0 0 2.624 20.3c1.87.502 9.376.502 9.376.502s7.505 0 9.376-.502a3.006 3.006 0 0 0 2.122-2.122C24 16.307 24 12.4 24 12.4s0-3.905-.502-5.776h.002Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fill: "#fff",
            d: "m9.6 16 6.237-3.6L9.6 8.8V16Z"
        })
    ]
});
YoutubeIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'YoutubeIcon'
};
export { YoutubeIcon };

//# sourceMappingURL=youtube.js.map